// extracted by mini-css-extract-plugin
export default {"panel":"Dialog_panel__pmvMo","backdrop":"Dialog_backdrop__t8qSN"};